import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dtm-container"
}
const _hoisted_2 = {
  key: 0,
  class: "header"
}

import { computed, markRaw, useTemplateRef, watch, type Component } from 'vue';
import { useRoute } from 'vue-router';

import { config } from '@services/user-config';
import { useRouteIs } from '@services/route-is';
import { routerStatePath } from '@services/route-state';
import initstate from '@services/init-state';
import * as strings from '@services/strings';

import AlbumDynamicTopMatter from './AlbumDynamicTopMatter.vue';
import FolderDynamicTopMatter from './FolderDynamicTopMatter.vue';
import PlacesDynamicTopMatterVue from './PlacesDynamicTopMatter.vue';
import OnThisDay from './OnThisDay.vue';

// Auto-hide top header on public shares if redundant
import './PublicShareHeader';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'DynamicTopMatter',
},
  __name: 'DynamicTopMatter',
  emits: ["load"],
  setup(__props, { expose: __expose, emit: __emit }) {



const emit = __emit;

const route = useRoute();
const routeIs = useRouteIs();

const child = useTemplateRef<{
  isReady: boolean;
  isContent: boolean;
  refresh(): Promise<void>;
}>('child');

const currentmatter = computed((): Component | null => {
  if (routeIs.Folders || (routeIs.FolderShare && initstate.shareType === 'folder')) {
    return markRaw(FolderDynamicTopMatter);
  } else if (routeIs.Places) {
    return markRaw(PlacesDynamicTopMatterVue);
  } else if (routeIs.Albums) {
    return markRaw(AlbumDynamicTopMatter);
  } else if (routeIs.Base && config.enable_top_memories) {
    return markRaw(OnThisDay);
  }

  return null;
});

/** Check if the component has loaded */
const isReady = computed((): boolean => {
  return !currentmatter.value || (child.value?.isReady ?? false);
});

/** Check if the component is content */
const isContent = computed((): boolean => {
  return !!currentmatter.value && (child.value?.isContent ?? false);
});

/** Get view name for dynamic top matter */
const viewName = computed((): string => {
  // Show album name for album view
  if (routeIs.Albums) {
    return strings.albumDisplayName(route.params.name?.toString() ?? String());
  }

  // Show share name for public shares, except for folder share,
  // because the name is already present in the breadcrumbs
  if (routeIs.Public && !routeIs.FolderShare) {
    return initstate.shareTitle;
  }

  // Only static top matter for these routes
  if (routeIs.Tags || routeIs.People || routeIs.Places) {
    return String();
  }

  return strings.viewName(route);
});

async function refresh(): Promise<void> {
  try {
    await child.value?.refresh?.();
  } catch (e) {
    console.error('[BUG] Disallowed throw in DynamicTopMatter::refresh():', e);
  }
}

watch(
  isReady,
  (newVal) => {
    if (newVal) emit('load');
  },
  { immediate: true },
);

__expose({ isReady, isContent, refresh });

return (_ctx: any,_cache: any) => {
  return (currentmatter.value || viewName.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (viewName.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(viewName.value), 1))
          : _createCommentVNode("", true),
        (currentmatter.value)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(currentmatter.value), {
              ref_key: "child",
              ref: child,
              key: _unref(routerStatePath)(_unref(route)),
              onLoad: _cache[0] || (_cache[0] = ($event: any) => (emit('load')))
            }, null, 32))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})